import {
	array,
	boolean,
	intersect,
	literal,
	number,
	partial,
	string,
	struct,
	union,
} from 'io-ts/Decoder';

import { Area } from '../ui/geometry';

export const FPCMetadata = intersect(
	struct({
		type: literal('fpc'),
		areas: array(Area),
		transactionIds: array(string),
		textDifferenceIds: array(number),
	})
)(
	partial({
		// optional: comments created before comment ids stopped carrying the variation
		variationId: string,
	})
);

export const RoofHITLMetadata = intersect(
	struct({
		type: literal('trussHitl'),
	})
)(
	partial({
		areas: array(Area),
	})
);

export const CanvasMetadata = intersect(
	struct({
		type: literal('canvas'),
		areas: array(Area),
	})
)(
	partial({
		number: number,
		internal: boolean,
	})
);

export const Metadata = union(FPCMetadata, RoofHITLMetadata, CanvasMetadata);
